import {FormatOptionLabelMeta} from "react-select";
import {ArrowRightIcon} from "../styles/ArrowRightIcon";
import {SearchOption} from "../types/Types";

/**
 * Render Network search option. Highlights matches in the searched text and indicates if the option is a node.
 */
export function renderOption(
  option: SearchOption,
  meta: FormatOptionLabelMeta<SearchOption>
) {
  const {symbol, searched} = option;

  // Simple label for selected option badge in search box
  if (meta.context === "value") {
    if (searched === symbol) {
      return <span>{symbol}</span>;
    }
    return (
      <span style={{display: "inline-flex", alignItems: "center", lineHeight: "1"}}>
        {searched}
        <ArrowRightIcon size={".8em"}/>
        {symbol}
      </span>
    );
  }

  // Highlight matches
  const regex = new RegExp(`(${meta.inputValue})`, "gi");
  const highlight = (text: string, override: boolean = false) => {
    if (override) return text;

    return text.split(regex)
      .map((part, index) =>
        regex.test(part) ? (
          <span key={index} style={{fontWeight: "bold", color: "var(--color-primary)"}}>
          {part}
        </span>
        ) : (
          part
        )
      );
  }

  return (
    <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", lineHeight: "1"}}>
      <span style={{display: "inline-flex", alignItems: "center"}}>
        {highlight(searched, option.gene?.d)}
        {searched !== symbol && (
          <>
            <ArrowRightIcon size={".8em"}/>
            {highlight(symbol, option.gene?.d)}
          </>
        )}
      </span>

      {/*Add node badge if option is a node*/}
      {!!option.gene?.d && (
        <span className="small">No sig. GIs</span>
      )}
    </div>
  );
}

/**
 * Convert search options to query string.
 *
 * @param options Current search options
 * @returns Query string of the form "searched::value,searched::value,..."
 */
export function optionsToQueryString(options: readonly SearchOption[]): string {
  return options.length ? options.map(opt => `${opt.searched}::${opt.value}`).join(",") : "";
}

/**
 * Cleanup disabled options from search results by removing them from the array.
 *
 * @param options Search results
 * @returns Filtered search results without disabled options
 */
export function optionsRemoveDisabled(options: readonly SearchOption[]): SearchOption[] {
  return options.filter(opt => !opt.gene?.d);
}